<script>
    import Section from '$lib/components/Section.svelte';
    import { getContext } from 'svelte';

    export let sections = [];

    // Merge shared modules into standard modules
    const mergeSharedModules = (data) => {
        return data.map((section) => {
            if (section?.modules) {
                const sharedModules = section.modules.flatMap((module) => module?.sharedModules || [module]);
                section.modules = sharedModules;
            }
            return section;
        });
    };
    sections = mergeSharedModules(sections);

    // component imports
    import ModuleHero from '$lib/components/Modules/ModuleHero.svelte';
    import ModuleProductCarousel from '$lib/components/Modules/ModuleProductCarousel.svelte';
    import ModuleRichText from '$lib/components/Modules/ModuleRichText.svelte';
    import ModuleAccordian from '$lib/components/Modules/ModuleAccordian.svelte';
    import ModuleCardGrid from '$lib/components/Modules/ModuleCardGrid.svelte';
    import ModulePageHeader from '$lib/components/Modules/ModulePageHeader.svelte';
    import ModuleVideo from '$lib/components/Modules/ModuleVideo.svelte';
    import ModuleBarGraph from '$lib/components/Modules/ModuleBarGraph.svelte';
    import ModuleActions from '$lib/components/Modules/ModuleActions.svelte';

    // component lookup map
    const componentLookup = [
        { type: 'module.hero', component: ModuleHero },
        { type: 'module.productCarousel', component: ModuleProductCarousel },
        { type: 'module.portableText', component: ModuleRichText },
        { type: 'module.accordian', component: ModuleAccordian },
        { type: 'module.cardGrid', component: ModuleCardGrid },
        { type: 'module.pageHeader', component: ModulePageHeader },
        { type: 'module.video', component: ModuleVideo },
        { type: 'module.barGraph', component: ModuleBarGraph },
        { type: 'module.action', component: ModuleActions }
    ];

    // Context for getting sectionPosition
    const ctx = getContext('ctx');

    const getComponent = (type) => {
        return componentLookup.find((item) => item.type == type)?.component;
    };
</script>

{#if sections}
    {#each sections as section (section)}
        <Section
            maxWidth={section?.maxWidth}
            padding={section?.padding}
            style={section?.style}
            title={section?.title}
            description={section?.description}
            alignment={section?.settings?.alignment}
            titleType={section?.settings?.titleType}
            headerVisibile={section?.settings?.visibile}
            device={section?.device}
            userVisibility={section?.userVisibility}
            userTag={section?.userTag}
            userSegmentID={section?.userSegmentID}
        >
            {#if section?.modules}
                {@const currentSectionPosition = ctx.sectionPosition.getSectionPosition()}
                <div
                    class={`relative grid ${section?.style === 'Featured' ? 'gap-8' : 'gap-2'} lg:gap-8 ${section?.layoutDesktop === '2 Columns' ? `${section?.itemsPosition || 'items-center'}  lg:grid-cols-2` : ''}`}
                >
                    {#each section?.modules as module, modulePosition (module)}
                        {@const svelteComponent = getComponent(module?._type)}
                        {#if svelteComponent}
                            <svelte:component this={svelteComponent} content={module} sectionPosition={currentSectionPosition} {modulePosition} />
                        {/if}
                    {/each}
                </div>
            {/if}
        </Section>
    {/each}
{/if}
